<button
  class="ui-avatar-button"
  type="button"
  [disabled]="disabled()"
  [attr.aria-label]="label()"
  (click)="handlePressed($event)"
>
  <ui-avatar
    [initials]="initials()"
    [label]="label()"
    [tone]="tone()"
    [size]="size()"
  />
</button>
